module.exports = __webpack_public_path__ + "img/Stripe_logo.fb4644a0.png";